export default __webpack_public_path__ + "static/media/Runic.3ad55a63.ttf";